import styled from 'styled-components';

import { IBasicStyledProps } from '@notino/react-styleguide-v20';

interface IImageWrapperProps extends IBasicStyledProps {
  width: number;
  height: number;
}

export const StyledImageWrapper = styled.a<IImageWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
`;
